import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AttachmentCountModal = ({
  maxFileLimit,
  closeModal,
  attachmentsCount,
  fileUploadsInProgCount
}) => {
  const remainingCount = maxFileLimit - attachmentsCount - fileUploadsInProgCount;
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: closeModal
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.title",
          options: {
            maxFileLimit
          }
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.body",
          options: {
            remainingCount
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: closeModal,
        use: "primary",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.okay"
        })
      })
    })]
  });
};
AttachmentCountModal.displayName = 'AttachmentCountModal';
AttachmentCountModal.propTypes = {
  attachmentsCount: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
  fileUploadsInProgCount: PropTypes.number,
  maxFileLimit: PropTypes.number
};
export default AttachmentCountModal;